module.exports = __webpack_public_path__ + "static/media/tendericon01@2x.110c0ebf.png";